import * as constants from './constants';

export default function User(state = {
  user: null,
  photo: null,
  favoriteListings: null,
  favorited: null
}, action) {
  switch (action.type) {
    case constants.SET_PROFILE_DATA:
      return Object.assign({}, state, {
        user: action.data
      });
    case constants.SET_PROFILE_PHOTO:
      return Object.assign({}, state, {
        photo: action.data
      });
    case constants.SET_FAVORITE_LISTINGS:
      return Object.assign({}, state, {
        favoriteListings: action.data
      });
    case constants.SET_FAVORITE_LISTING:
      return Object.assign({}, state, {
        favorited: action.data
      });
    default:
      return state;
  }
}
